import type { Config } from "tailwindcss";

export const cubeCustomColors = {
  cubeBrand: {
    100: "#BFDFF7", // mainBlueLight
    200: "#5da2d2", //mainBlueDark
    700: "fb923c", //orange used it settings wheel (same or tailwind orange 400 )
    800: "ffa726", //Dark orange used it settings wheel (same or tailwind orange 600 )
    900: "#FC6A08", // ORANGE - logo orange in the top corner.
  },
  cubeBase: {
    500: "#FFFFFF", // Background of the main widgets.
    600: "#7B7B7B", // SVG icon colour.
    700: "#EBEBEB", // Hover over SVGs
    800: "#F2F3F3", // 'Bubbles' over background.
    900: "#FFFFFF", // Background. - Off white
  },
  cubeBaseDark: {
    300: "#EBEBEB",
    400: "#D3D3D3", //Text colour for tables
    500: "#1B1919", // Background of the main widgets.
    // OLD // 500: "#27272A", // Background of the main widgets.
    600: "#7B7B7B", // SVG icon colour.
    700: "#313237", // Hover over SVGs
    800: "#222222", // 'Bubbles' over background.
    900: "#000000", // Background.
  },
  cubeTableRowColour: {
    200: "#90CAF9", // LightMode Dropdown Hover
    300: "#BBDEFB", // LightMode Dropdown Odd
    400: "#90CAF9", // DarkMode Dropdown Hover - lighter blue
    500: "#BBDEFB", // DarkMode Dropdown Odd - lighter blue
    600: "#b1d3ec57", // LightMode Hover
    700: "#e5f0fc ", // LightMode Odd
    750: "#eef7fd", // LightMode Main
    800: "#343f4f", // DarkMode Hover - lighter blue
    900: "#2c3644", // DarkMode Odd - lighter blue
    950: "#1f2937", // DarkMode Main - lighter blue
  },
  OPTableRowColour: {
    // Change in CSS too!
    // LIGHT MODE
    400: "#d4ddf3c4", // LightMode hover
    500: "#E5E6F3", // LightMode odd
    600: "#E5EAF8", // LightMode main
    // DARK MODE
    700: "#323253bf", // DarkMode hover
    800: "#3A3A53", // DarkMode odd
    900: "#2F2F42", // DarkMode main
  },
  // RPTableRowColour: {
  //   // LIGHT MODE
  //   400: "#B1D484", // LightMode hover
  //   500: "#C4DFA3", // LightMode odd
  //   600: "#ddeede", // LightMode main
  //   // DARK MODE
  //   700: "#3551358c", // DarkMode hover
  //   800: "#283b28a8", // DarkMode odd
  //   900: "#233322", // DarkMode main
  // },

  ButtonColour: {
    100: "#EF4444", //Exit button
    //LIGHT MODE
    200: "#F3F4F6", //LightMode Secondary action button
    300: "#FDBA74", //LightMode Primary action button
    400: "#7CD3FC", // LightMode Active toggle
    500: "#E5E7EB", //LightMode Inactive toggle

    //DARK MODE
    600: "#334155", // DarkMode Secondary action button
    700: "#FB923C", // DarkMode Primary action button
    800: "#37BDF8", // DarkMode Active toggle
    900: "#4B5563", //DarkMode Inactive toggle
  },
};

const config: Config = {
  content: [
    // Root-level entry files (App.tsx, main.tsx) hold the shell layout classes.
    "./src/*.{js,ts,jsx,tsx,mdx}",
    "./src/pages/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/components/**/*.{js,ts,jsx,tsx,mdx}",
    // lib holds JSX too (EditableText, Draggable/DroppableAnalytics); without
    // this glob their unique classes are silently missing from the CSS.
    "./src/lib/**/*.{js,ts,jsx,tsx,mdx}",
  ],
  theme: {
    extend: {
      backgroundImage: {
        "gradient-radial": "radial-gradient(var(--tw-gradient-stops))",
        "gradient-conic":
          "conic-gradient(from 180deg at 50% 50%, var(--tw-gradient-stops))",
      },
      colors: cubeCustomColors,
    },
  },
  darkMode: "class",

  plugins: [],
};
export default config;
